import { CommonModule } from '@angular/common';
import { Component, HostListener, OnInit } from '@angular/core';
import { AppResource } from 'src/app/app.resource';
import { BaseComponent } from 'src/app/shared/components/base/base.component';
import { PathType } from 'src/app/shared/enum/path-type.enum';
import { isMobile } from 'src/app/shared/utils/device-utils';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-web-callback',
  templateUrl: './web-callback.component.html',
  standalone: true,
  imports: [CommonModule],
})
export class WebCallbackComponent extends BaseComponent implements OnInit {
  show: boolean = false;
  phoneNumber!: string;
  path!: PathType;

  loadPhone: boolean = false;
  get brand() {
    return environment.brand;
  }

  constructor(resources: AppResource) {
    super(resources);
  }

  override ngOnInit(): void {
    if (!this.store.contactPhone()) {
      this.loadPhone = true;

      this.handlerService.apiHandlersPhoneByProductAndBrandGet().subscribe({
        next: (response) => {
          this.store.updateHandlerContactPhone(response.phone!);
          this.phoneNumber = response.phone!;
        },
        error: (err) => {
          console.error('Error fetching handler phone:', err);
          this.loadPhone = false;
        },
        complete: () => {
          this.loadPhone = false;
        },
      });
    }
    this.phoneNumber = this.store.contactPhone() ?? '';
  }

  clickFunction() {
    this.show = !this.show;
  }

  callClientService(): void {
    if (isMobile()) {
      window.location.href = `tel:${this.phoneNumber}`;
    }
  }

  @HostListener('document:click', ['$event'])
  closeInfoModal() {
    this.show = false;
  }
}
